module.exports = __webpack_public_path__ + "img/dol 58.65b27dbb.png";